import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { TypeActionApp } from "../app/actionApp";
import { actionDependencyInjection } from "./actionDependencyInjection";
export var epicDependencyInjection = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), mapTo(actionDependencyInjection(deps.inStoreDependencies)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/dep-injection/epicDependencyInjection.ts
// module id = 1828
// module chunks = 3